import logo from "../../assets/img/png/logo-1.png";
import descriptiveLogo from "../../assets/img/png/logo-2.png";

import React from "react";
import { Box } from "@mui/material";
// The descriptiveLogo is not used in this component, but you could add logic to switch between them if needed.
// import descriptiveLogo from '../../assets/img/png/logo-2.png';

export const MainLogo = () => {
  return (
    <Box
      component="img" // Renders the Box as an <img> HTML tag
      src={logo}
      alt="main logo"
      sx={{
        // Set a specific height. The header's height will be defined by this.
        height: "40px", // You can adjust this value (e.g., '2.5rem', '50px')

        // 'auto' will preserve the image's aspect ratio
        width: "auto",

        // Good practice to ensure it aligns well within a flex container like Toolbar
        verticalAlign: "middle",
      }}
    />
  );
};
export interface ILogo{
  height: number
}
export const DescriptiveLogo: React.FC<ILogo> = ({height}) => {
  return (
    <Box
      component="img"
      src={descriptiveLogo}
      sx={{
        height: `${height}rem`,
        width: "auto",
       
      }}
    />
  );
};
